import { Component, inject } from '@angular/core';
import { LetregisterService } from './letregister.service';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from 'primeng/tabs';
import { LetregisterSearchComponent } from './letregister-search/letregister-search.component';
import { LetregisterResultComponent } from './letregister-aftaler/letregister-aftaler.component';
import { LetregisterDetailComponent } from './letregister-detail/letregister-detail.component';

@Component({
  selector: 'app-letregister',
  imports: [
    LetregisterSearchComponent,
    LetregisterResultComponent,
    LetregisterDetailComponent,
    Tabs,
    TabList,
    Tab,
    TabPanels,
    TabPanel,
  ],
  templateUrl: './letregister.component.html',
  styleUrl: './letregister.component.css',
})
export class LetregisterComponent {
  letregisterService = inject(LetregisterService);
  data = this.letregisterService.letsikringDatasource.data;
}
